import React from 'react';
import { Paper, Grid, Box, CircularProgress, Tooltip } from '@mui/material';
import styles from './summaryCard.module.scss';
import { Icon } from 'components';
import strings from 'strings';

interface ISummaryCardProps {
    isLoading: boolean;
    icon: string;
    iconColor: string;
    value: string | number | null | undefined;
    tooltipText?: string;
    title: string;
    subtitle: string;
    footerText?: string;
    borderColor?: string;
    bgColor?: string;
    id: string;
}

const SummaryCard: React.FC<ISummaryCardProps> = ({
    isLoading,
    icon,
    iconColor,
    value,
    tooltipText,
    title,
    subtitle,
    footerText,
    borderColor = '#E9E9E9',
    bgColor = '#fefeff',
    id,
}) => {
    const paperStyles = {
        p: 2,
        borderRadius: '14px',
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        border: `1px solid ${borderColor}`,
        backgroundColor: bgColor,
    };

    const renderValue = () => {
        if (isLoading) {
            return <CircularProgress size={30} sx={{ my: 2, display: 'block', mx: 'auto' }} />;
        }
        if (value === null || value === undefined || value === '' || value === 0 || value === '0') {
            return <div className={styles.noDataLabel}>{strings.SUMMARY_REPORT.SUMMARY_CARDS.NO_DATA}</div>;
        }
        const displayValue = <div className={styles.metricValue}>{value}</div>;
        return tooltipText ? (
            <Tooltip title={tooltipText} placement="top">
                {displayValue}
            </Tooltip>
        ) : (
            displayValue
        );
    };

    return (
        <Grid item xs={12} sm={4} md={4} lg={2}>
            <Paper elevation={0} sx={paperStyles} id={id}>
                <Box>
                    <Icon materialIcon={icon} color={iconColor} size={25} />
                    {renderValue()}
                    <div className={styles.metricLabel}>{title}</div>
                    <div className={styles.metricSubtitle}>{subtitle}</div>
                </Box>
                <Box>
                    {footerText && (
                        <div className={styles.metricSubtitle}>
                            {footerText}
                        </div>
                    )}
                </Box>
            </Paper>
        </Grid>
    );
};

export default SummaryCard;